<template>
  <div class="modal" id="myModalInsurance" tabindex="-1" role="dialog" aria-labelledby="myModalInsuranceLabel" v-if="remaining > 0">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">เดิมพันประกันภัย</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-3">
              <div class="badge clock">
                {{ remaining | number('00') }}
              </div>
            </div>
            <div class="col-md-9">
              <h3>{{ whoIsOnOffer }}</h3>
              <p>
                <label>ราคาต่อรอง</label>
                <span style="font-size:30px;">
                  1:<span class="text-danger">{{ insurance.rate }}</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  let tickCountdown
  export default {
    name: 'baccarat-insurance',
    props: {
      insurance: {
        required: true
      },
      onTimeup: {
        type: Function,
        required: true
      }
    },
    data () {
      return {
        remaining: 0
      }
    },
    computed: {
      whoIsOnOffer () {
        const who = this.insurance.insurance === 'PLAYER' ? 'ผู้เล่น' : 'เจ้ามือ'
        return `เดิมพันประกันภัย ${who}`
      }
    },
    methods: {
      startCountdown () {
        if (this.remaining == 0) return
        clearInterval(tickCountdown)
        tickCountdown = setInterval(() => {
          this.remaining--
          if (this.remaining === 0) {
            this.onTimeup()
            clearInterval(tickCountdown)
          }
        }, 1000)
      }
    },
    watch: {
      'insurance.remaining': {
        handler: function (value, old) {
          if (value === null) return
          this.remaining = value
          this.startCountdown()
        },
        deep: true
      },
    }
  }
</script>
<style scoped>
  .modal { display: block; }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/dealer/BaccaratInsurance.vue